import {
  CUSTOMER_TYPE,
  ILabelForm,
  ILabelMutation,
  SETTLEMENT_METHOD,
} from 'services/labels/types';
import { isUnder18 } from 'utils/components/isUnder18';
import { unknownEnumValueConverter } from 'utils/global/valueConverter.utils';

export const labelFormToQuery = (labelForm: ILabelForm): ILabelMutation => {
  const { residenceCertificates, reports, ...label } = {
    ...labelForm,
    settlementMethod: unknownEnumValueConverter<SETTLEMENT_METHOD>(
      labelForm.settlementMethod
    ),
    ...(labelForm.customerType === CUSTOMER_TYPE.Company
      ? {
          personalIdCountryAlfa2: '',
          personalId: '',
        }
      : { companyCountryAlfa2: '', companyId: '' }),
    ...(labelForm.dateOfBirth && !isUnder18(labelForm.dateOfBirth)
      ? {
          legalSupervisorFirstName: '',
          legalSupervisorLastName: '',
          legalSupervisorPersonalId: '',
          legalSupervisorCountryAlfa2: '',
        }
      : {}),
    bankAccountNumber: labelForm.bankAccountNumber,
    routingNumber:
      (labelForm.customerType === CUSTOMER_TYPE.Physical
        ? labelForm.personalIdCountryAlfa2
        : labelForm.companyCountryAlfa2) === 'US'
        ? labelForm.routingNumber
        : null,
  };

  return label;
};
